import { call, put, takeEvery } from "redux-saga/effects";

import {
  GET_TRANSACTION_HISTORY,
  GET_TRANSACTION_HISTORY_V2,
  GetTransactionHistoryAction,
  GetTransactionHistoryV2Action,
} from "./actionTypes";
import {
  getTransactionHistoryError,
  getTransactionHistorySuccess,
  getTransactionHistoryV2Error,
  getTransactionHistoryV2Success,
} from "./actions";
import { PaginateQuery } from "../../models";
import { ResponseGenerator } from "../../interfaces";
import {
  getTransactionHistory,
  getTransactionHistoryV2,
} from "../../helpers/backend_helper";

function* getTransactionHistorySaga({
  payload: { request },
}: GetTransactionHistoryAction) {
  try {
    const response: ResponseGenerator = yield call(
      getTransactionHistory,
      request as PaginateQuery
    );
    yield put(getTransactionHistorySuccess(response.data));
  } catch (error) {
    yield put(getTransactionHistoryError(error));
  }
}

function* getTransactionHistoryV2Saga({
  payload: { request },
}: GetTransactionHistoryV2Action) {
  try {
    const response: ResponseGenerator = yield call(
      getTransactionHistoryV2,
      request as PaginateQuery
    );
    yield put(getTransactionHistoryV2Success(response.data));
  } catch (error) {
    yield put(getTransactionHistoryV2Error(error));
  }
}

function* TransactionSaga() {
  yield takeEvery(GET_TRANSACTION_HISTORY, getTransactionHistorySaga);
  yield takeEvery(GET_TRANSACTION_HISTORY_V2, getTransactionHistoryV2Saga);
}

export default TransactionSaga;
